module.exports = __webpack_public_path__ + "img/icon_sms_white.571e1c1.svg";